<template>
  <section class="layout" :style="{minHeight: overHeight + 'px'}">
    <div class="layout-top">
      <mul-head class="layout-header">
        <template v-slot:logo> 
          <div class="layout-header-logo">
            <router-link to="/">
              <!-- <img src='../assets/phlogo.png' /> -->
              <h2 class="article-item-title">- 上海趋致信息技术 -</h2>
            </router-link>
          </div>
        </template>
        <template v-slot:nav>
          <mul-nav class="layout-header-nav" :navList="navList"/>
        </template>
      </mul-head>
    </div>
    <div class="layout-view">
      <router-view :key="key" />
    </div>
    <div class="layout-bot">
      <mul-foot class="layout-footer">
        <div slot="ba-copy" class="layout-footer-copy">
          <a class="copy" href="http://beian.miit.gov.cn/">———————&nbsp;&nbsp;&nbsp;&copy; 2020-2021 版权所有 上海趋致信息技术有限公司 沪ICP备2022024036号-1&nbsp;&nbsp;&nbsp;———————</a>
        </div>
      </mul-foot>
    </div>
  </section>
</template>

<script>
import mulHead from '@/components/Head.vue'
import mulNav from '@/components/Nav.vue'
import mulFoot from '@/components/Foot.vue'
export default {
  components: {
    mulHead,
    mulNav,
    mulFoot
  },
  props: {},
  data () {
    return {
      overHeight: window.innerHeight,
      navList: [{
        path: '/',
        name: 'home',
        text: '首页'
      }, {
        path: '/reports',
        name: 'reports',
        text: '关于'
      },
      {
        path: '/down',
        name: 'down',
        text: '下载'
      }
      ]
    }
  },
  watch: {},
  computed: {
    key() {
      return this.$route.path
    }
  },
  methods: {},
  created () {},
  mounted () {}
}
</script>
<style scoped>
.layout {
  position: relative;
  min-width: 1200px;
}
.layout-top {
  position: absolute;
  width: 100%;
  z-index: 1;
}
.layout-header {
  height: 70px;
  padding: 0 88px;
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
}
.layout-header-logo {
  float: left;
  line-height: 36px;
}
.layout-header-logo img{
  margin-top: 15px;
  float: left;
}
.layout-header-logo span {
  float: left;
  color: #fff;
  font-size: 24px;
  margin-left: 20px;
  font-weight: 500;
}
.layout-header-nav {
  float: right;
}
.layout-bot {
  width: 100%;
  position: absolute;
  bottom: 0;
}
.layout-footer-copy {
  width: 100%;
  height: 200px;
  position: absolute;
  background-color: #F1F1F1;
  color: rgba(255, 255, 255);
  text-align: center;
  line-height: 50px;
  font-size: 14px;
}
.layout-view {
  /* width: 1200px; */
  margin: 0 auto;
}
.layout-bot {
  height: 50px;
}
.copy {
    color: #666666;
    margin-top: 100px;
}
.police {
  vertical-align: middle;
}
.layout-footer-copy a {
  display: block;
  height: 40px;
}
.article-item-title{
    color: #fff;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 32px;
    line-height: 70px;
}
</style>